import { replaceValue } from './replaceValue.ts';

/**
 * Returns a new array with the first value that matches test replaced with newValue.
 */
export function replaceValueMatching<T>(arr: readonly T[], test: (value: T, index: number, arr: readonly T[]) => boolean, newValue: T): T[] {
  const value = arr.find(test);

  return replaceValue(arr, value, newValue);
}